import { render, staticRenderFns } from "./AuthenticationChooseProfile.vue?vue&type=template&id=156492b0&scoped=true&"
import script from "./AuthenticationChooseProfile.vue?vue&type=script&lang=js&"
export * from "./AuthenticationChooseProfile.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationChooseProfile.vue?vue&type=style&index=0&id=156492b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156492b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156492b0')) {
      api.createRecord('156492b0', component.options)
    } else {
      api.reload('156492b0', component.options)
    }
    module.hot.accept("./AuthenticationChooseProfile.vue?vue&type=template&id=156492b0&scoped=true&", function () {
      api.rerender('156492b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthenticationChooseProfile.vue"
export default component.exports